import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';

// Inter, as in v1, bundled rather than fetched from a CDN — a school office on
// a bad line should not have its interface reflow because fonts.googleapis.com
// is slow, and the app must not depend on a third party being reachable.
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';
// Inter has no Devanagari coverage and the app ships a Hindi locale, so the
// script is named explicitly instead of being left to an arbitrary OS
// substitution. This is the only font addition to v1.
import '@fontsource/noto-sans-devanagari/400.css';
import '@fontsource/noto-sans-devanagari/500.css';
import '@fontsource/noto-sans-devanagari/600.css';

import './styles/tokens.css';
import './i18n';
import { App } from './App';
import { queryClient } from './lib/query';
import { initAnalytics } from './lib/analytics';
import { ToastProvider } from './ui';

// Before the first render, so the opening screen view is not missed.
// Autocapture is off and replay is sampled and masked — see lib/analytics.ts.
initAnalytics();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <ToastProvider>
          <App />
        </ToastProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
